import { useContext } from "react"
import { ProjectContext } from "~/contexts/project"

export default function useProjectContext() {
  const context = useContext(ProjectContext)
  return context
}
